export interface Artwork {
  id: number;
  title: string;
  category: string;
  artist: string;
  style: string;
  year: string;
  tags: string[];
  description: string;
  image: string;
  featured?: boolean;
}

export interface StyleCollection {
  id: number;
  name: string;
  desc: string;
  count: number;
  image: string;
}

export const categories = [
  { key: "all", label: "全部图集" },
  { key: "原画", label: "原画设定" },
  { key: "插画", label: "精美插画" },
  { key: "画风", label: "风格画作" },
  { key: "壁纸", label: "高清壁纸" },
];

export const artworks: Artwork[] = [
  {
    id: 1,
    title: "《暮色琉璃》",
    category: "原画",
    artist: "林屿",
    style: "新国风 · 水墨重彩",
    year: "2026",
    tags: ["山水", "古风", "原画"],
    description: "以敦煌壁画为灵感的原创设定，勾勒出暮色下琉璃山水的静谧与恢弘。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20glazed%20turquoise%20mountain%20at%20dusk%20with%20golden%20mist%2C%20traditional%20shanshui%20landscape%2C%20elegant%20brushwork%2C%20warm%20amber%20and%20teal%20tones%2C%20refined%20art%20style&width=800&height=1000&seq=artwork-01&orientation=portrait",
    featured: true,
  },
  {
    id: 2,
    title: "《星河回响》",
    category: "插画",
    artist: "苏晚",
    style: "赛博幻想",
    year: "2026",
    tags: ["宇宙", "少女", "插画"],
    description: "在霓虹与星海之间，少女聆听宇宙的回响，画面充满流动的光影层次。",
    image: "https://readdy.ai/api/search-image?query=cyberpunk%20fantasy%20illustration%20of%20a%20young%20girl%20among%20neon%20stars%20and%20galaxy%2C%20flowing%20light%20ribbons%2C%20vibrant%20magenta%20and%20cyan%20glow%2C%20detailed%20digital%20art&width=800&height=1000&seq=artwork-02&orientation=portrait",
    featured: true,
  },
  {
    id: 3,
    title: "《和风庭院》",
    category: "原画",
    artist: "北川",
    style: "日式浮世绘",
    year: "2025",
    tags: ["庭院", "和风", "原画"],
    description: "枫叶与石灯笼构成的和风庭院一角，色彩清雅，氛围宁静悠远。",
    image: "https://readdy.ai/api/search-image?query=ukiyo%20e%20style%20japanese%20garden%20courtyard%20with%20maple%20leaves%20and%20stone%20lantern%2C%20calm%20refined%20colors%2C%20traditional%20woodblock%20print%20aesthetic&width=1000&height=750&seq=artwork-03&orientation=landscape",
  },
  {
    id: 4,
    title: "《花朝令》",
    category: "插画",
    artist: "江月",
    style: "唯美少女",
    year: "2026",
    tags: ["花卉", "汉服", "插画"],
    description: "身着华服的少女于繁花中回眸，笔触细腻，光影温柔动人。",
    image: "https://readdy.ai/api/search-image?query=elegant%20chinese%20hanfu%20girl%20amid%20blossoming%20flowers%20turning%20back%20glance%2C%20soft%20romantic%20lighting%2C%20delicate%20brush%20detail%2C%20beautiful%20anime%20illustration&width=800&height=1000&seq=artwork-04&orientation=portrait",
    featured: true,
  },
  {
    id: 5,
    title: "《城市黄昏》",
    category: "画风",
    artist: "陈默",
    style: "都市写实",
    year: "2025",
    tags: ["城市", "光影", "画风"],
    description: "黄昏时分的高楼剪影与街灯初亮，冷暖对比极具电影感。",
    image: "https://readdy.ai/api/search-image?query=realistic%20city%20silhouette%20at%20dusk%20with%20street%20lamps%20turning%20on%2C%20warm%20cold%20color%20contrast%2C%20cinematic%20atmosphere%2C%20matte%20painting%20style&width=1000&height=750&seq=artwork-05&orientation=landscape",
  },
  {
    id: 6,
    title: "《星野漫游》",
    category: "壁纸",
    artist: "阿澈",
    style: "治愈星空",
    year: "2026",
    tags: ["星空", "治愈", "壁纸"],
    description: "躺在草地上仰望极光星河，色彩梦幻，适合作为高清桌面壁纸。",
    image: "https://readdy.ai/api/search-image?query=healing%20aurora%20night%20sky%20over%20grassy%20hill%20with%20person%20lying%20and%20stargazing%2C%20dreamy%20violet%20and%20teal%20aurora%2C%20peaceful%20wallpaper%20art&width=1200&height=675&seq=artwork-06&orientation=landscape",
  },
  {
    id: 7,
    title: "《孤舟问雪》",
    category: "画风",
    artist: "林屿",
    style: "留白水墨",
    year: "2025",
    tags: ["山水", "冬雪", "画风"],
    description: "极简留白的水墨雪景，一叶孤舟，意境空灵而深远。",
    image: "https://readdy.ai/api/search-image?query=minimalist%20chinese%20ink%20painting%20of%20a%20lone%20boat%20on%20snowy%20river%2C%20large%20empty%20white%20space%2C%20zen%20tranquil%20mood%2C%20delicate%20brushwork&width=800&height=1000&seq=artwork-07&orientation=portrait",
  },
  {
    id: 8,
    title: "《山海绘卷》",
    category: "原画",
    artist: "祝遥",
    style: "玄幻国风",
    year: "2026",
    tags: ["神兽", "山海经", "原画"],
    description: "以山海经神兽为原型的原创设定，色彩浓烈，肌理丰富。",
    image: "https://readdy.ai/api/search-image?query=mythical%20beast%20from%20shan%20hai%20jing%20legend%20with%20vivid%20scale%20texture%2C%20rich%20saturated%20colors%2C%20chinese%20fantasy%20concept%20art%2C%20dragon%20and%20cloud%20motif&width=1000&height=750&seq=artwork-08&orientation=landscape",
    featured: true,
  },
  {
    id: 9,
    title: "《梦境来信》",
    category: "插画",
    artist: "小鹿",
    style: "童话治愈",
    year: "2025",
    tags: ["梦境", "暖色", "插画"],
    description: "漂浮在云端的信封与星光，传递温柔治愈的童话气息。",
    image: "https://readdy.ai/api/search-image?query=fairytale%20healing%20illustration%20of%20floating%20envelope%20and%20stars%20among%20soft%20clouds%2C%20warm%20golden%20glow%2C%20gentle%20dreamy%20color%20palette&width=800&height=1000&seq=artwork-09&orientation=portrait",
  },
  {
    id: 10,
    title: "《森林电台》",
    category: "壁纸",
    artist: "阿澈",
    style: "复古插画",
    year: "2026",
    tags: ["森林", "复古", "壁纸"],
    description: "复古收音机旁的小动物与丛林植物，色彩复古温暖，趣味盎然。",
    image: "https://readdy.ai/api/search-image?query=vintage%20retro%20illustration%20of%20cute%20animals%20beside%20a%20retro%20radio%20in%20a%20lush%20forest%2C%20warm%20faded%20colors%2C%20whimsical%20storybook%20style&width=1200&height=675&seq=artwork-10&orientation=landscape",
  },
  {
    id: 11,
    title: "《浮生若梦》",
    category: "画风",
    artist: "顾青",
    style: "古典工笔",
    year: "2025",
    tags: ["工笔", "古典", "画风"],
    description: "细腻工笔勾勒的古典仕女与庭园，线描精妙，色彩温润。",
    image: "https://readdy.ai/api/search-image?query=refined%20gongbi%20brushwork%20painting%20of%20classical%20chinese%20lady%20in%20garden%2C%20fine%20line%20detail%2C%20soft%20warm%20traditional%20colors%2C%20elegant&width=800&height=1000&seq=artwork-11&orientation=portrait",
  },
  {
    id: 12,
    title: "《夜航星图》",
    category: "壁纸",
    artist: "苏晚",
    style: "太空科幻",
    year: "2026",
    tags: ["宇宙", "飞船", "壁纸"],
    description: "星舰穿越璀璨星云的壮阔画面，色彩深邃，适合高清壁纸收藏。",
    image: "https://readdy.ai/api/search-image?query=starship%20flying%20through%20glowing%20nebula%20clouds%2C%20deep%20space%20sci-fi%20concept%20art%2C%20rich%20cosmic%20colors%2C%20epic%20wallpaper&width=1200&height=675&seq=artwork-12&orientation=landscape",
    featured: true,
  },
];

export const styleCollections: StyleCollection[] = [
  {
    id: 1,
    name: "国风水墨",
    desc: "以留白与晕染见长，营造诗意的东方意境。",
    count: 328,
    image: "https://readdy.ai/api/search-image?query=chinese%20ink%20wash%20landscape%20with%20misty%20mountains%20and%20flying%20birds%2C%20black%20and%20white%20with%20subtle%20teal%20wash%2C%20poetic%20oriental%20style&width=700&height=500&seq=style-01&orientation=landscape",
  },
  {
    id: 2,
    name: "唯美少女",
    desc: "光影温柔、细节精致，深受喜爱的治愈系画风。",
    count: 452,
    image: "https://readdy.ai/api/search-image?query=beautiful%20anime%20girl%20portrait%20with%20soft%20pastel%20lighting%20and%20flowing%20hair%2C%20delicate%20features%2C%20dreamy%20atmosphere%2C%20healing%20style&width=700&height=500&seq=style-02&orientation=landscape",
  },
  {
    id: 3,
    name: "赛博幻想",
    desc: "霓虹与科技交织，构筑未来都市的视觉盛宴。",
    count: 276,
    image: "https://readdy.ai/api/search-image?query=futuristic%20neon%20city%20street%20with%20holograms%20and%20rain%2C%20cyberpunk%20concept%20art%2C%20vivid%20magenta%20and%20cyan%20lighting&width=700&height=500&seq=style-03&orientation=landscape",
  },
  {
    id: 4,
    name: "治愈星空",
    desc: "星海与极光交织，带来宁静而治愈的视觉体验。",
    count: 198,
    image: "https://readdy.ai/api/search-image?query=calm%20night%20sky%20with%20milky%20way%20galaxy%20and%20soft%20stars%2C%20soothing%20blue%20teal%20palette%2C%20peaceful%20scenery%20painting&width=700&height=500&seq=style-04&orientation=landscape",
  },
  {
    id: 5,
    name: "古典工笔",
    desc: "线描细腻、设色温润，尽显传统美学风骨。",
    count: 154,
    image: "https://readdy.ai/api/search-image?query=traditional%20chinese%20gongbi%20painting%20of%20peonies%20and%20birds%20with%20fine%20outline%20and%20soft%20colors%2C%20elegant%20classical%20style&width=700&height=500&seq=style-05&orientation=landscape",
  },
  {
    id: 6,
    name: "都市写实",
    desc: "细腻光影还原城市肌理，画面充满电影质感。",
    count: 232,
    image: "https://readdy.ai/api/search-image?query=realistic%20urban%20scene%20of%20rainy%20city%20street%20with%20reflections%2C%20cinematic%20moody%20lighting%2C%20detailed%20matte%20painting&width=700&height=500&seq=style-06&orientation=landscape",
  },
];